import NewTrans from './NewTrans.vue';

export default NewTrans;


// WEBPACK FOOTER //
// ./src/components/NewTrans/index.js